import React from "react";

const WindowHeader = ({
  title,
  logo,
  onClose,
  className = "",
  titleClassName = "",
  logoClassName = "",
  closeBtnClassName = "",
  style = {},
  showClose = true,
}) => {
  const btnClasses = closeBtnClassName ? closeBtnClassName.split(/\s+/) : [];
  const hasWidth = btnClasses.some(c => c.startsWith("w-"));
  const hasHeight = btnClasses.some(c => c.startsWith("h-"));
  const hasBg = btnClasses.some(c => c.startsWith("bg-"));

  const defaultWidth = hasWidth ? "" : "w-11";
  const defaultHeight = hasHeight ? "" : "h-full";
  const defaultBg = hasBg ? "" : "bg-red-600 hover:bg-red-700";

  const headerClasses = className ? className.split(/\s+/) : [];
  const hasHeaderBg = headerClasses.some(c => c.startsWith("bg-"));
  const hasHeaderTextColor = headerClasses.some(c => c.startsWith("text-"));

  const defaultHeaderBg = hasHeaderBg ? "" : "bg-[#1a3abf]";
  const defaultHeaderTextColor = hasHeaderTextColor ? "" : "text-white";

  const hasRounded = headerClasses.some(c => c.startsWith("rounded"));
  const defaultRounded = hasRounded ? "" : "rounded-t-[10px]";

  return (
    <div
      className={`w-full h-11 ${defaultHeaderBg} ${defaultHeaderTextColor} font-Inter font-semibold flex items-center justify-between p-0 box-border ${defaultRounded} ${className}`}
      style={style}
    >
      <div className="flex items-center gap-1.5 p-2 h-full">
        {logo && (
          <img
            src={logo}
            alt="Logo"
            className={`h-5 w-auto object-contain ${logoClassName}`}
          />
        )}
        <span className={`text-sm ${titleClassName}`}>{title}</span>
      </div>

      {showClose && onClose && (
        <button
          type="button"
          onClick={onClose}
          className={`${defaultHeight} ${defaultWidth} ${defaultBg} flex items-center justify-center text-white font-bold transition-colors duration-200 focus:outline-none ${closeBtnClassName}`}
          aria-label="Close"
        >
          {/* A clean, customizable white 'X' close icon */}
          <svg
            className="w-4 h-4 fill-current"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M18.3 5.71a1 1 0 00-1.41 0L12 10.59 7.11 5.7a1 1 0 10-1.41 1.41L10.59 12l-4.89 4.89a1 1 0 001.41 1.41L12 13.41l4.89 4.89a1 1 0 001.41-1.41L13.41 12l4.89-4.89a1 1 0 000-1.41z"
            />
          </svg>
        </button>
      )}
    </div>
  );
};

export default WindowHeader;
